import { FrameHeader } from "./FrameHeader";
import { Tlv } from "./Tlv";
import { Sink, skip_bytes } from "../../helpers/serializerHelpers";

export class Frame {

    public header: FrameHeader = new FrameHeader();
    public tlvs: Tlv[] = [];

    public deserialize(bytes: Sink) {
        this.header.deserialize(bytes);

        if (this.header.numTLVs > 50) {
            throw new Error(`Invalid TLV Count - radar data is not valid (${this.header.numTLVs} TLVs > 50 Limit)`);
            return;
        }

        //else logger.LogTrace($"Received {header.NumTLVs} TLVs");
        this.tlvs = new Array<Tlv>(this.header.numTLVs);
        var totalTlvLength = 0;
        for (var i = 0; i < this.header.numTLVs; i++) {
            this.tlvs[i] = new Tlv().deserialize(this.header, bytes);
            //console.log("TLV", this.tlvs[i]);
            totalTlvLength += this.tlvs[i].getTotalLength();
        }

        //Read padding bytes
        var paddingLength = this.header.packetLength - totalTlvLength - this.header.getLength();
        if (paddingLength > 0) {
            if (paddingLength > 64) {
                //console.log(`Invalid Padding Length: ${paddingLength}. Skipping frame.`);
                return;
            }

            skip_bytes(bytes, paddingLength);
        }
        return this;
    }
}

